import {
	ChangeDetectionStrategy,
	Component,
	EventEmitter,
	Inject,
	Input,
	Output,
} from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { PersonClient } from '@models/clients';
import { IDVModalSteps, IDVStatus } from '@models/idv';
import { IdvService } from '@services/idv/idv.service';
import {
	IdvRequestModalComponent,
	IdvRequestModalData,
} from '../../idv-modal.component';
import { TestHooks } from './cancel-requests.hooks';

@Component({
	selector: 'app-cancel-requests',
	templateUrl: './cancel-requests.component.html',
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: false,
})
export class CancelRequestsComponent {
	testHooks = TestHooks;

	@Input() set selectedClients(selectedClients: Partial<PersonClient>[]) {
		this._selectedClients = selectedClients.filter((client) =>
			[IDVStatus.REQUEST_SENT, IDVStatus.REQUEST_EXPIRED].includes(
				client?.idv?.status,
			),
		);
	}
	@Input() public hasCheckboxes = true;

	@Output() public sendModalEvent = new EventEmitter<IDVModalSteps>();

	public _selectedClients: Partial<PersonClient>[] = [];
	public isCancelling = false;
	private standaloneModal = false;

	constructor(
		private idvService: IdvService,
		public dialogRef: MatDialogRef<IdvRequestModalComponent>,
		@Inject(MAT_DIALOG_DATA)
		public data: IdvRequestModalData,
	) {
		this._selectedClients = data.selectedClients ?? [];
		this.standaloneModal = data.standaloneModal ?? false;
	}

	onBackHandler(): void {
		this.standaloneModal
			? this.closeModal()
			: this.sendModalEvent.emit(IDVModalSteps.CLIENTS_SELECT);
	}

	cancelIDVRequest(): void {
		this.isCancelling = true;

		this.idvService
			.cancelIDVRequest(this._selectedClients.map(({ idv }) => idv))
			.subscribe(
				() => {
					// Handle the data that was fetched from the service
					this.closeModal();
					this.isCancelling = false;
				},
				(error) => {
					console.error(error);
					this.closeModal();
				},
			);
	}

	getButtonText(): string {
		return this._selectedClients.length > 1
			? 'Cancel Requests'
			: 'Cancel Request';
	}

	private closeModal(): void {
		this.dialogRef.close();
	}
}
